import React from "react";
import { useEffect } from "react";
import { Grid, Stack, Typography } from "@mui/material";
import { useDispatch } from "react-redux";
import TopSection from "../../../Components/Common/Top/TopSection";
import MaterialConfig from "./MaterialConfig";
import { setActiveDataElement } from "../../../redux/userSlice";

function MaterialPlanning(){
 const dispatch = useDispatch();

 useEffect(() => {
   dispatch(setActiveDataElement("Bottler Concentrate Forecast"));
 }, [dispatch]);

 return(
    <>
    <Stack>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <TopSection
              labelList={[
                { title: "Home", path: "/mapping-configuration" },
                { title: "Mapping Configuration" },
              ]}
              title = "Mapping Configuration"
            />
            <div class = "container">
              <MaterialConfig></MaterialConfig>
            </div>
          </Grid>
        </Grid>
      </Stack>
    </>
 )
}

export default MaterialPlanning